import React from 'react';

const SvgSixttenToNine = props => (
    <svg width="1em" height="1em" viewBox="0 0 14 14" {...props}>
        <g fill="none" fillRule="evenodd" stroke="#000">
            <path d="M1.5 3.5h11v7h-11z" />
            <path
                fill="#FFF"
                d="M.5 2.5h3v3h-3zM10.5 2.5h3v3h-3zM.5 8.5h3v3h-3zM10.5 8.5h3v3h-3z"
            />
        </g>
    </svg>
);

export default SvgSixttenToNine;
